import { Join } from 'design-studio/lib'

interface DiagramModelArtifactsProps {
  className?: string
  blueClassName?: string
  textClassName?: string
  surfaceClassName?: string
  centerSurfaceClassName?: string
}

export function DiagramModelArtifacts({
  className,
  blueClassName = 'text-blue-500 dark:text-blue-300',
  textClassName = 'text-slate-800 dark:text-slate-200',
  surfaceClassName = 'text-indigo-50 dark:text-slate-900',
  centerSurfaceClassName = 'text-slate-100 dark:text-slate-900',
}: DiagramModelArtifactsProps) {
  return (
    <svg
      viewBox="0 0 320 161"
      className={Join('h-auto w-full', className)}
      fill="none"
      aria-label="Diagram showing requirements, source code, tests, and logs connected to a central model"
    >
      {/* Arrows */}
      <path
        d="M112 31.9999L114.989 43.1535L123.154 34.9886L112 31.9999ZM136 56L133.011 44.8464L124.846 53.0114L136 56ZM118.364 38.3639L117.657 39.071L128.929 50.3431L129.636 49.636L130.343 48.9289L119.071 37.6568L118.364 38.3639Z"
        className={textClassName}
        fill="currentColor"
      />
      <path
        d="M184.247 104.186L187.221 115.343L195.397 107.189L184.247 104.186ZM208 128L205.026 116.843L196.85 124.997L208 128ZM190.603 110.558L189.895 111.264L200.936 122.334L201.644 121.628L202.352 120.922L191.311 109.852L190.603 110.558Z"
        className={textClassName}
        fill="currentColor"
      />
      <path
        d="M183.993 55.999L195.152 53.0305L187.001 44.8509L183.993 55.999ZM208.059 32.0192L196.9 34.9877L205.05 43.1674L208.059 32.0192ZM190.368 49.6465L191.074 50.3549L202.389 39.0801L201.684 38.3717L200.978 37.6633L189.662 48.9381L190.368 49.6465Z"
        className={textClassName}
        fill="currentColor"
      />
      <path
        d="M111.934 128.371L123.093 125.403L114.942 117.223L111.934 128.371ZM136 104.391L124.841 107.36L132.991 115.539L136 104.391ZM118.309 122.019L119.015 122.727L130.33 111.452L129.624 110.744L128.919 110.035L117.603 121.31L118.309 122.019Z"
        className={textClassName}
        fill="currentColor"
      />

      {/* Center model diamond */}
      <path
        d="M164.142 38.9888L201.263 76.1098C203.508 78.3553 203.508 81.996 201.263 84.2415L164.493 121.011C162.248 123.257 158.607 123.257 156.361 121.011L119.24 83.89C116.995 81.6445 116.995 78.0038 119.24 75.7583L156.01 38.9888C158.255 36.7432 161.896 36.7432 164.142 38.9888Z"
        className={centerSurfaceClassName}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
      />
      <path
        d="M164.142 38.9888L201.263 76.1098C203.508 78.3553 203.508 81.996 201.263 84.2415L164.493 121.011C162.248 123.257 158.607 123.257 156.361 121.011L119.24 83.89C116.995 81.6445 116.995 78.0038 119.24 75.7583L156.01 38.9888C158.255 36.7432 161.896 36.7432 164.142 38.9888Z"
        className={blueClassName}
        fill="none"
        stroke="currentColor"
        strokeWidth="0.5"
      />

      {/* Cards */}
      <rect
        x="0.25"
        y="0.25"
        width="111.5"
        height="31.5"
        rx="5.75"
        className={surfaceClassName}
        fill="currentColor"
      />
      <rect
        x="0.25"
        y="0.25"
        width="111.5"
        height="31.5"
        rx="5.75"
        className={blueClassName}
        fill="none"
        stroke="currentColor"
        strokeWidth="0.5"
      />
      <rect
        x="208.25"
        y="0.25"
        width="111.5"
        height="31.5"
        rx="5.75"
        className={surfaceClassName}
        fill="currentColor"
      />
      <rect
        x="208.25"
        y="0.25"
        width="111.5"
        height="31.5"
        rx="5.75"
        className={blueClassName}
        fill="none"
        stroke="currentColor"
        strokeWidth="0.5"
      />
      <rect
        x="208.497"
        y="128.621"
        width="111.253"
        height="31.5"
        rx="5.75"
        className={surfaceClassName}
        fill="currentColor"
      />
      <rect
        x="208.497"
        y="128.621"
        width="111.253"
        height="31.5"
        rx="5.75"
        className={blueClassName}
        fill="none"
        stroke="currentColor"
        strokeWidth="0.5"
      />
      <rect
        x="0.25"
        y="128.25"
        width="111.434"
        height="31.5"
        rx="5.75"
        className={surfaceClassName}
        fill="currentColor"
      />
      <rect
        x="0.25"
        y="128.25"
        width="111.434"
        height="31.5"
        rx="5.75"
        className={blueClassName}
        fill="none"
        stroke="currentColor"
        strokeWidth="0.5"
      />

      {/* Labels */}
      <text
        x="56"
        y="18"
        textAnchor="middle"
        dominantBaseline="middle"
        className={textClassName}
        fill="currentColor"
        fontSize="10.5"
        fontFamily="system-ui,sans-serif"
        fontWeight="500"
      >
        Requirements
      </text>
      <text
        x="264"
        y="18"
        textAnchor="middle"
        dominantBaseline="middle"
        className={textClassName}
        fill="currentColor"
        fontSize="10.5"
        fontFamily="system-ui,sans-serif"
        fontWeight="500"
      >
        Source code
      </text>
      <text
        x="56"
        y="146"
        textAnchor="middle"
        dominantBaseline="middle"
        className={textClassName}
        fill="currentColor"
        fontSize="10.5"
        fontFamily="system-ui,sans-serif"
        fontWeight="500"
      >
        Tests
      </text>
      <text
        x="264"
        y="146"
        textAnchor="middle"
        dominantBaseline="middle"
        className={textClassName}
        fill="currentColor"
        fontSize="10.5"
        fontFamily="system-ui,sans-serif"
        fontWeight="500"
      >
        Logs
      </text>
      <text
        x="160"
        y="81"
        textAnchor="middle"
        dominantBaseline="middle"
        className={textClassName}
        fill="currentColor"
        fontSize="12"
        fontFamily="system-ui,sans-serif"
        fontWeight="500"
      >
        Model
      </text>
    </svg>
  )
}
